import {RESET_PRICING, RESET_PRICING_ORIGINAL_STATE} from '../Constants';

interface IPricingPackage {
  [key: string]: any;
}

type Action = {
  type: string;
};

type State = {
  pricingPackages: IPricingPackage;
  firstVisitPricingPackages?: IPricingPackage;
  selectedVisitId?: string;
  pricingApplicationInProgress: boolean;
  generatePricing?: any[];
  selectedDraftIds?: any[];
  appliedPricingIds?: any[];
  firstPricingLoading: boolean;
  pricingGroup: number;
};

export default (
  state: State = {
    pricingPackages: [],
    firstVisitPricingPackages: [],
    pricingApplicationInProgress: false,
    firstPricingLoading: true,
    pricingGroup: 0,
  },
  action: Action,
) => {
  switch (action.type) {
    case RESET_PRICING:
      state.generatePricing = [];
      state.pricingPackages = [];
      state.appliedPricingIds = [];
      state.selectedDraftIds = [];
      state.pricingGroup = 0;
      return {...state};
    case RESET_PRICING_ORIGINAL_STATE:
      state.generatePricing = [];
      state.pricingPackages = [];
      state.selectedDraftIds = [];
      state.appliedPricingIds = [];
      state.pricingGroup = 0;
      return {...state};
    default:
      return state;
  }
};
